import React from 'react'
import getTranslationData from '../../TranslationUtility/TranslationUtility';
import processingPaymentImg from "../../Assets/PaymentProcessingImg.png";
import { Link } from 'react-router-dom';
const ProcessingPayment = () => {
    const translation = getTranslationData();

    return (
        <div className="fix d-flex flex-column justify-content-center align-items-center text-center">
            <img src={processingPaymentImg} className="responsive-image"></img>
            <div className="payment-processing-heading">{translation?.processing_payment_heade_msg}</div>
            <p className="payment-processing-message">{translation?.processing_payment_description_msg_1}</p>
            <p className='payment-processing-message mb-0'>{translation?.processing_payment_description_msg_2}</p>
            <div className='payment-processing-color-label'>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#DA3442"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="16" x2="12" y2="12" />
                    <line x1="12" y1="8" x2="12" y2="8" />
                </svg>
                <span className="">{translation.payment_processing_color_label}</span>
            </div>
            <Link className="continue-shopping-btn" to={"/productlist"}>
                {translation?.continue_shopping}
            </Link>
            <Link className="view-order-btn" to={"/orders"}>
                {translation?.view_orders}
            </Link>
        </div >

    )
}

export default ProcessingPayment